/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { modalExperience } from './modalExperience.styles';

type Props = {
  label: string;
  required?: boolean;
  children: React.ReactNode;
  /** Estilo extra del wrapper (ej. flex:1 en layout de 2 columnas). */
  style?: StyleProp<ViewStyle>;
};

export function ModalFormField({ label, required = false, children, style }: Props) {
  return (
    <View style={[modalExperience.formField, style]}>
      <View style={modalExperience.formLabelRow}>
        <Text style={modalExperience.formLabel}>{label}</Text>
        {required ? <Text style={modalExperience.requiredBadge}>*</Text> : null}
      </View>
      {children}
    </View>
  );
}
